import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
// import 'bootstrap/dist/css/bootstrap.min.css';

import "react-toastify/dist/ReactToastify.css";
import Login from "./pages/Login/Login";
import Footer from "./components/common/Footer/Footer";
import SplashScreen from "./components/loader/SplashScreen/SplashScreen";
import Dashboard from "./pages/dashboard/Dashboard";
import Sidebar from "./components/common/Sidebar/Sidebar";
import UtilityBills from "./pages/UtilityBills/UtilityBills";
import BalanceTransfer from "./pages/Orders/Orders";
// import BankTransfer from "./pages/BankTransfer/BankTransfer";
import PrivateRoutes from "./Routes/PrivateRoutes";
import Customer from "./pages/Customers/Customer";
import NotFound from "./components/common/Notfound";
import Role from "./pages/RoleManagement/Role";
import SurveyCreate from "./pages/Surveys/SurveyCreate";
import SurveyList from "./pages/Surveys/SurveyList";
import CampaignsList from "./pages/Surveys/CampaignsList";
import CampaignResponseList from "./pages/Surveys/CampaignResponseList";

import { Logout } from "./utils/Cipher";
import axios from "axios";
import { PermissionsProvider } from "./context/PermissionsContext";
import CampaignRecepientList from "./pages/Surveys/CampaignRecepientList";
import SheRunsApplications from "./pages/SheRuns/SheRunsApplications";




// axios interceptor Global error handler for 401 errors that calls the logout function from Cipher.jsx.
// This is a global solution, so you won't need to add error handling for 401 errors in individual components
// this will logout the user and redirect them to the login page

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status == 419) {
      Logout();
    }
    return Promise.reject(error);
  }
);




function App() {
  return (
    <>
      <BrowserRouter>
        <PermissionsProvider>
        <Routes>
          <Route
            path="/"
            element={
              <div>
                <Login />
              </div>
            }
          />

          {/* <Route path="/splash-screen" element={<SplashScreen />} /> */}

          {/* Protected Routes */}
          <Route element={<PrivateRoutes />}>
            <Route
              path="/dashboard"
              element={
                <div>
                  <div uk-grid="" className="uk-grid">
                    <div className="uk-width-auto">
                      <Sidebar />
                    </div>
                    <div
                      className="uk-width-expand"
                      style={{ paddingLeft: "60px" }}
                    >
                      <Dashboard />
                      {/* <Footer /> */}
                    </div>
                  </div>
                </div>
              }
            />
            {/* <Route
              path="/bills"
              element={
                <div>
                  <div uk-grid="" className="uk-grid">
                    <div className="uk-width-auto">
                      <Sidebar />
                    </div>
                    <div
                      className="uk-width-expand"
                      style={{ paddingLeft: "60px" }}
                    >
                      <UtilityBills />
                      <Footer />
                    </div>



                    
                  </div>
                </div>
              }
            /> */}
            <Route
              path="/customers"
              element={
                <div>
                  <div uk-grid="" className="uk-grid">
                    <div className="uk-width-auto">
                      <Sidebar />
                    </div>
                    <div
                      className="uk-width-expand"
                      style={{ paddingLeft: "60px" }}
                    >
                      <Customer />
                      <Footer />
                    </div>
                  </div>
                </div>
              }
            />
            <Route
              path="/Orders"
              element={
                <div>
                  <div uk-grid="" className="uk-grid">
                    <div className="uk-width-auto">
                      <Sidebar />
                    </div>
                    <div
                      className="uk-width-expand"
                      style={{ paddingLeft: "60px" }}
                    >
                      <BalanceTransfer />
                      <Footer />
                    </div>
                  </div>
                </div>
              }
            />
            <Route
              path="/role-management"
              element={
                <div>
                  <div uk-grid="" className="uk-grid">
                    <div className="uk-width-auto">
                      <Sidebar />
                    </div>
                    <div
                      className="uk-width-expand"
                      style={{ paddingLeft: "60px" }}
                    >
                      <Role />
                      <Footer />
                    </div>
                  </div>
                </div>
              }
            />
            <Route
              path="/survey-create"
              element={
                <div>
                  <div uk-grid="" className="uk-grid">
                    <div className="uk-width-auto">
                      <Sidebar />
                    </div>
                    <div
                      className="uk-width-expand"
                      style={{ paddingLeft: "60px" }}
                    >
                      <SurveyCreate />
                      <Footer />
                    </div>
                  </div>
                </div>
              }
            />
            <Route
              path="/survey-management"
              element={
                <div>
                  <div uk-grid="" className="uk-grid">
                    <div className="uk-width-auto">
                      <Sidebar />
                    </div>
                    <div
                      className="uk-width-expand"
                      style={{ paddingLeft: "60px" }}
                    >
                      <SurveyList />
                      <Footer />
                    </div>
                  </div>
                </div>
              }
            />
            <Route
              path="/survey-campaigns"
              element={
                <div>
                  <div uk-grid="" className="uk-grid">
                    <div className="uk-width-auto">
                      <Sidebar />
                    </div>
                    <div
                      className="uk-width-expand"
                      style={{ paddingLeft: "60px" }}
                    >
                      <CampaignsList />
                      <Footer />
                    </div>
                  </div>
                </div>
              }
            />
            <Route
              path="/campaign-responses/:id"
              element={
                <div>
                  <div uk-grid="" className="uk-grid">
                    <div className="uk-width-auto">
                      <Sidebar />
                    </div>
                    <div
                      className="uk-width-expand"
                      style={{ paddingLeft: "60px" }}
                    >
                      <CampaignResponseList />
                      <Footer />
                    </div>
                  </div>
                </div>
              }
            />
            <Route
              path="/campaign-recepients/:id"
              element={
                <div>
                  <div uk-grid="" className="uk-grid">
                    <div className="uk-width-auto">
                      <Sidebar />
                    </div>
                    <div
                      className="uk-width-expand"
                      style={{ paddingLeft: "60px" }}
                    >
                      <CampaignRecepientList />
                      <Footer />
                    </div>
                  </div>
                </div>
              }
            />
            <Route
              path="/she-runs-applications"
              element={
                <div>
                  <div uk-grid="" className="uk-grid">
                    <div className="uk-width-auto">
                      <Sidebar />
                    </div>
                    <div
                      className="uk-width-expand"
                      style={{ paddingLeft: "60px" }}
                    >
                      <SheRunsApplications />
                      <Footer />
                    </div>
                  </div>
                </div>
              }
            />

            {/* Not Found Page  */}
            <Route
              path="*"
              element={
                <>
                  <Sidebar />
                  <NotFound />
                </>
              }
            />
          </Route>
        </Routes>
        </PermissionsProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
